import { type FullPaymentMethodFragment } from '../../types/graphql'

export default function formatPaymentMethodTitle (paymentMethod: FullPaymentMethodFragment): string {
  return paymentMethod.name ?? 'Namn saknas'
}
